import { useEffect, useState, useContext } from "react";

import { Form, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import Axios from "axios";
import hocFrom from "../../../components/forms/HocFrom";
import Mobilecheckexist from "../../../components/inputs/Mobilecheckexist";
import Loader from "../../../components/layout/Loader";
import DashboardContext from "../../../Context";
import InputNumber from "../../../components/inputs/InputNumber";
import Timer from "../../../components/hooks/Timer";
import MobileChangeCheckExist from "../../../components/inputs/MobileChangeCheckExist";

function ChangeNumberForm({
  loding,
  handelLoadingform,
  LoadingForm,
  dataUpdate,
  setDataUpdate,
  info,
  mustRefetch = false,
}) {
  const {
    urldashboard,
    authentication,
    handelAdd,
    changeNumber,
    HandlechangeNumber,
  } = useContext(DashboardContext);

  const [isReady, setisReady] = useState(false);
  const [code, setcode] = useState(0);
  const [newData, setnewData] = useState({});
  const [active, setactive] = useState(false);
  const [oldNumber, setoldNumber] = useState(dataUpdate?.cellPhone);
  const [newNumber, setnewNumber] = useState(null);
  const pathName = window.location.pathname;

  const handelValue = (name, value) => {
    setactive(false);
    switch (name) {
      case "old":
        // handelsetdataForm({ ...formdata, old: value });
        setoldNumber(value);
        // checkNumberExistance(value, "old");
        break;
      case "new":
        setnewNumber(value);
        checkNumberExistance(value, "new");
        break;
      case "confirmCode":
        setcode(value);
        break;
      default:
        break;
    }
  };

  const checkLength = newNumber?.toString().length !== 11;

  useEffect(() => {
    setisReady(false);
    if (checkLength) setactive(false);
  }, [checkLength]);

  const fetchDataByProp = async () => {
    setoldNumber(info?.cellPhone);
    setDataUpdate({
      ...dataUpdate,
      cellPhone: info?.cellPhone,
      fullName: info?.fullName,
    });
  };

  const fetchData = async () => {
    const url = `${urldashboard}/customer/getinfo/` + changeNumber;
    const res = await Axios.get(url, {
      headers: {
        Authorization: authentication,
        "Content-Type": "application/json; charset=utf-8 ",
      },
    });
    setoldNumber(res?.data?.data?.cellPhone);
    setDataUpdate({
      ...dataUpdate,
      cellPhone: res?.data?.data?.cellPhone,
      fullName: res?.data?.data?.fullName,
    });
  };

  const submitChangeNumber = async () => {
    handelLoadingform(true);

    const params = {
      cellPhone: dataUpdate?.cellPhone,
      newCellPhone: newNumber,
      confirmCode: parseInt(code),
    };
    try {
      const res = await Axios.put(
        `${urldashboard}/userManagement/changecellphone`,
        params,
        {
          headers: {
            Authorization: authentication,
            "Content-Type": "application/json; charset=utf-8 ",
          },
        }
      );
      setnewData(res?.data);

      toast.success(res?.data.message, {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      handelAdd(false);
      HandlechangeNumber(false);
    } catch (err) {
      toast.error(err?.response?.data?.message, {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    handelLoadingform(false);
  };

  const sendCode = async (e) => {
    e.preventDefault();
    const params = {
      cellPhone: newNumber,
      personType: pathName === "/Customer" ? 0 : 2,
      businessType: 1,
    };
    try {
      const res = await Axios.post(
        `${urldashboard}/userManagement/sendconfirmcode`,
        params,
        {
          headers: {
            Authorization: authentication,
            "Content-Type": "application/json; charset=utf-8 ",
          },
        }
      );
      toast.success(res?.data?.message, {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setisReady(!isReady);
      setactive(true);
    } catch (err) {
      toast.error(err?.response?.data?.message, {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const handelSubmit = (event) => {
    event.preventDefault();
    handelLoadingform(true);
    submitChangeNumber();
    // handelLoadingform(false)
  };

  const checkNumberExistance = async (data, method) => {
    // handelLoadingform(true)
    checkExistance(data, method);
    handelLoadingform(false);
  };

  const checkExistance = async (data, method) => {
    try {
      const res = await Axios.get(`${urldashboard}/userManagement/checkexist/` + data, {
        headers: {
          Authorization: authentication,
          "Content-Type": "application/json; charset=utf-8 ",
        },
      });
      if (method === "new") {
        setnewData(res?.data);
      } else {
      }
    } catch (err) {
      setnewData({
        data: { fullName: "این شماره در سامانه موجود نمیباشد." },
      });
    }
  };

  useEffect(() => {
    mustRefetch ? fetchData() : fetchDataByProp();
  }, []);

  return (
    <>
      {loding ? (
        <Loader />
      ) : (
        <Form>
          <Form.Row style={{ alignItems: "center" }}>
            <Col>
              <Mobilecheckexist
                urlPorfile='Worker'
                label='شماره قدیم'
                name='old'
                disabled
                value={dataUpdate?.cellPhone || oldNumber}
                handelValue={handelValue}
                defaultValue={dataUpdate?.cellPhone}
              />
            </Col>
            <Col>
              {dataUpdate?.fullName}
              {dataUpdate?.profile === "Worker" && " - نیرو"}
              {dataUpdate?.profile === "Customer" && " - مشتری"}
            </Col>
            <Col></Col>
            <Col>
              <InputNumber
                label='کد تایید'
                name='confirmCode'
                value={code}
                maxLength='5'
                id='myInput'
                handelValue={handelValue}
              />
            </Col>
            <Col></Col>
          </Form.Row>
          <Form.Row style={{ alignItems: "center" }}>
            {
              <Col>
                <MobileChangeCheckExist
                  urlPorfile='Worker'
                  label='شماره جدید'
                  name='new'
                  value={newNumber}
                  handelValue={handelValue}
                  onChangeFunction={() => setactive(false)}
                  newData={newData}
                  handleResponse={(value) => setnewData(...value)}
                  noSearch
                />
              </Col>
            }
            <Col>
              <span style={{ color: newData?.data?.color }}>
                {newData?.data?.fullName}
                {newData?.data?.profile === "Worker" && " - نیرو"}
                {newData?.data?.profile === "Customer" && " - مشتری"}
              </span>
            </Col>
            <Col></Col>

            <Col>
              <Form.Row style={{ justifyContent: "space-between" }}>
                {
                  <button
                    // type="submit"
                    className='btn btn-success'
                    onClick={(e) => sendCode(e)}
                    disabled={!isReady === false ? true : false}
                  >
                    {LoadingForm ? (
                      <i className='fa fa-spinner fa-pulse fa-fw'></i>
                    ) : (
                      "ارسال کد"
                    )}
                  </button>
                }{" "}
                {active && <Timer duration={120} active={active} />}
              </Form.Row>
            </Col>

            <Col></Col>
          </Form.Row>
          <Form.Row>
            <Col></Col>
            <Col>
              <Form.Row style={{ justifyContent: "flex-end" }}>
                <button
                  type='submit'
                  className='btn btn-success'
                  onClick={handelSubmit}
                  disabled={code?.length !== 5}
                >
                  {LoadingForm ? (
                    <i className='fa fa-spinner fa-pulse fa-fw'></i>
                  ) : (
                    "ثبت"
                  )}
                </button>
              </Form.Row>
            </Col>
          </Form.Row>
        </Form>
      )}
    </>
  );
}
export default hocFrom(ChangeNumberForm);
